export default class UserSalesInfo {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.countStudents = 0;
    this.countEducationalCategories = 0;
    this.userToken = "";
    this.userNameCurrent = "";
    this.fullCode = "";
    this.userName = "";
    this.userPhoneWithCC = "";
    this.userImagePath = "";
    this.userTypeToken = "";
    this.userTypeNameCurrent = "";
    this.userJobGradeToken = "";
    this.userJobGradeNameCurrent = "";
    this.userJobGradeImagePath = "";
  }
  fillData(data) {
    if (data) {
      this.countStudents = data.countStudents ?? 0;
      this.countEducationalCategories = data.countEducationalCategories ?? 0;
      this.userToken = data.userToken ?? "";
      this.userNameCurrent = data.userNameCurrent ?? "";
      this.fullCode = data.fullCode ?? "";
      this.userName = data.userName ?? "";
      this.userPhoneWithCC = data.userPhoneWithCC ?? "";
      this.userImagePath = data.userImagePath ?? "";
      this.userTypeToken = data.userTypeToken ?? "";
      this.userTypeNameCurrent = data.userTypeNameCurrent ?? "";
      this.userJobGradeToken = data.userJobGradeToken ?? "";
      this.userJobGradeNameCurrent = data.userJobGradeNameCurrent ?? "";
      this.userJobGradeImagePath = data.userJobGradeImagePath ?? "";
    } else {
      this.setInitialValue();
    }
  }
}
